import { RefObject } from 'react';

export const enum Block {
  BlockLeft,
  BlockMiddle,
  BlockRight,
}

export interface IScrollManager {
  blockLeftRef: RefObject<HTMLDivElement | null>;
  blockMiddleRef: RefObject<HTMLDivElement | null>;
  blockRightRef: RefObject<HTMLDivElement | null>;
  handleScroll: (BlockType: Block) => void;
  scrollToTop: () => void;
  isButtonVisible: boolean;
}
